const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1']);

function getLocalBackendUrl() {
  if (typeof window === 'undefined') return '';
  if (!LOCAL_HOSTNAMES.has(window.location.hostname)) return '';
  return 'http://127.0.0.1:8001';
}

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');

export const BACKEND_URL = getLocalBackendUrl() || configuredBackendUrl;
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';
